import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'auto' | 'light' | 'dark';
type LayoutStore = {
  sidebarCollapsed: boolean;
  theme: Theme;
  toggleSidebar: () => void;
  setTheme: (theme: Theme) => void;
};

export const useLayoutStore = create<LayoutStore>()(
  // NOTE(OLA): theme init depends on this local storage entry in index.html
  persist(
    (set, get) => ({
      sidebarCollapsed: false,
      theme: 'auto',
      toggleSidebar: () => { set({ sidebarCollapsed: !get().sidebarCollapsed }); },
      setTheme: (theme: Theme) => { set({ theme }); },
    }),
    {
      name: 'layout-storage',
    },
  ),
);
